module.exports = __webpack_public_path__ + "media/customizations/simplyartavia/logo-13eb4608bc7a28628378ee0a07c7976e.png";